var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.profe.nombre)+" "+_vm._s(_vm.profe.apellido))]),_c('td',[_vm._v(_vm._s(_vm.profe.alumnos.length)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }